// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
require('@js/slick/slick.min.js');
require('@js/index');

require('@js/slider');
